"use strict";

exports.__esModule = true;
exports.useRestApi = void 0;
var _react = _interopRequireWildcard(require("react"));
var _RestAPIContext = require("./RestAPIContext");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var ACTIONS = {
  LOADING: "loading",
  DATA: "data",
  ERROR: "error"
};
var initialState = {
  loading: true,
  data: [],
  error: undefined
};
var reducer = function reducer(state, action) {
  switch (action.type) {
    case ACTIONS.LOADING:
      {
        if (typeof action.payload === "boolean") {
          return Object.assign({}, state, {
            loading: action.payload
          });
        }
        return state;
      }
    case ACTIONS.ERROR:
      {
        return Object.assign({}, state, {
          error: action.payload
        });
      }
    case ACTIONS.DATA:
      {
        if (Array.isArray(action.payload)) {
          return Object.assign({}, state, {
            data: action.payload
          });
        }
        return state;
      }
    default:
      {
        return state;
      }
  }
};
var useRestApi = exports.useRestApi = function useRestApi(props) {
  var url = props.url,
    options = props.options,
    formatDataProps = props.formatDataProps,
    _props$shouldSendRequ = props.shouldSendRequest,
    shouldSendRequest = _props$shouldSendRequ === void 0 ? true : _props$shouldSendRequ;
  var api = _react["default"].useContext(_RestAPIContext.RestAPIContext);
  var _useReducer = (0, _react.useReducer)(reducer, initialState),
    state = _useReducer[0],
    dispatcher = _useReducer[1];
  var _useState = (0, _react.useState)(false),
    shouldReload = _useState[0],
    setShouldReload = _useState[1];
  var reload = function reload() {
    return setShouldReload(!shouldReload);
  };
  var reset = function reset(loading, mounted, error) {
    if (mounted) {
      dispatcher({
        type: ACTIONS.LOADING,
        payload: loading
      });
      dispatcher({
        type: ACTIONS.DATA,
        payload: []
      });
      dispatcher({
        type: ACTIONS.ERROR,
        payload: error
      });
    }
  };
  var isValidPostOrPut = ["POST", "PUT"].includes(options.method) ? options.body !== null : true;
  var isOptionsValid = options && isValidPostOrPut;
  (0, _react.useEffect)(function () {
    var isMounted = true;
    var abortController = new window.AbortController();
    var signal = abortController.signal;
    if (!isOptionsValid || !shouldSendRequest) {
      reset(false, true);
    }
    if (isMounted && url && isOptionsValid && shouldSendRequest) {
      reset(true, isMounted);
      api.makeRequest(url, options, signal).then(function (data) {
        if (isMounted) {
          dispatcher({
            type: ACTIONS.LOADING,
            payload: false
          });
          var payload = formatDataProps.shouldFormat ? formatDataProps.formatFn(data) : data;
          dispatcher({
            type: ACTIONS.DATA,
            payload: payload
          });
        }
      })["catch"](function (error) {
        if (isMounted) {
          reset(false, isMounted, error);
        }
        if (!abortController.signal.aborted) {
          console.error("Error making request", error);
        }
      });
    }
    return function () {
      isMounted = false;
      if (signal && abortController.abort) {
        abortController.abort("Multiple request created with same data");
      }
    };
  }, [url, options, shouldReload]);
  return Object.assign({}, state, {
    reload: reload
  });
};